import TablaAgrupada from "../../ComponentesGlobales/TablaAgrupada";
import { useStoreEntrada } from "./useStoreEntradas";
import Mensaje from "sweetalert";
import demo from "../../icons/pregunta.png";
import EntradasReporte from "./EntradasReporte";
import moment from "moment";

export default function EntradasTab2() {

    const ListaDetalleGrilla = useStoreEntrada((state) => state.ListaDetalleGrilla);
    
    return (
        <div className="prod-bloque-registros">

            <div title="Reportes" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h3 className="prod-subtitulo">
                    Detalles de Registros 
                </h3>
                <EntradasReporte />
            </div>
            <div className="ing-detalle">
                <TablaAgrupada
                    
                    data={ListaDetalleGrilla}
                    groupBy={[{ label: "Proceso", key: (r) => r.Proceso || 'Sin proceso' },]}
                    rowId={(r) => r.IdentificadorId ?? r.IdentificadorId ?? r.Id ?? r.sCodbar}

                    columns={[
                    { header: "Código QR", field: "sCodbar", width: 120, align: "center" },
                    { header: "Cantidad", field: "nPeso", width: 120, align: "center" },
                    { header: "Unidad", field: "UnidadDescripcion", width: 120, align: "center" },
                    { header: "Lote", field: "sLote", width: 120, align: "center" },
                    { header: "QR Ingreso", field: "Original", width: 120, align: "center" },
                ]}
                onDelete={(nivel, { records, node, ids }) => {
                    const titulo = nivel === "Proceso"
                        ? `Eliminar TODO el proceso "${node?.data?.g1}"?`
                        : `Eliminar el producto "${records?.[0]?.MercaderiaDescripcion ?? ""}"?`;

                    Mensaje({
                        title: titulo,
                        icon: demo,
                        buttons: ["Cancelar", "Aceptar"],
                        dangerMode: true,
                    }).then((ok) => {
                        if (!ok) return;
                        useStoreEntrada.getState().eliminarEntrada(records);
                    });
                }}
                showLeafRecords={true}
                />
            </div>
        </div>
    );
}